import React, { ChangeEvent, MouseEvent, useEffect, useRef } from 'react';
import cx from 'classnames';

import { CloseIcon } from 'components/close/close-icon';
import Loading from 'components/loading/loading';

import styles from './search-field.module.css';

// TODO: the placeholders are not translated (kept as they were)
const DEFAULT_PLACEHOLDER = 'Search TPE... (players, teams, games, stats)';
const MOBILE_PLACEHOLDER = 'Search TPE...';

type SearchFieldProps = {
    isMobile: boolean;
    /** the input is shown and focused; otherwise a pill that opens it */
    isActive: boolean;
    value: string;
    onClick: (event: MouseEvent) => void;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
    onCancel: () => void;
    processing: boolean;
    placeholder?: string;
};

/** The search field of the header */
export const SearchField = ({
    isMobile,
    isActive,
    value,
    onClick,
    onChange,
    onCancel,
    processing,
    placeholder
}: SearchFieldProps) => {
    const inputRef = useRef<HTMLInputElement>(null);
    const shownPlaceholder = placeholder || (isMobile ? MOBILE_PLACEHOLDER : DEFAULT_PLACEHOLDER);

    useEffect(() => {
        if (isActive) {
            inputRef.current?.focus();
        }
    }, [isActive]);

    if (isActive) {
        return (
            <div className={cx(styles.inputWrap, { [styles.compact]: isMobile })}>
                <input
                    ref={inputRef}
                    className={styles.input}
                    type="text"
                    value={value || ''}
                    onChange={onChange}
                    placeholder={shownPlaceholder}
                    aria-label="Search TPE"
                />
                <button type="button" className={styles.clear} onClick={onCancel} aria-label="Close search">
                    {processing ? <Loading spinner /> : null}
                    <CloseIcon />
                </button>
            </div>
        );
    }

    return (
        <button type="button" className={cx(styles.trigger, { [styles.compact]: isMobile })} onClick={onClick}>
            <span className={styles.triggerText}>{shownPlaceholder}</span>
            {isMobile ? null : <span className={styles.shortcutHint}>/</span>}
        </button>
    );
};
